// removed by extract-text-webpack-plugin
module.exports = {"SpacingSM":"10px","list":"G1049d5 Gd2f6fe G7a726b","listItem":"G16fb0b G1b59f4 Gf3d5f3 Gf83f38","textBold":"Gb861f7 G42bbcd"};